var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaregiversIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -2084)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 2084)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1356 2107)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1313.938 2085.6)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.628,51.849,37.064,14.2A3.332,3.332,0,0,0,35.8,12.88a3.391,3.391,0,0,0-3.477,0A3.332,3.332,0,0,0,31.069,14.2L10.5,51.849a3.219,3.219,0,0,0,.06,3.357,4.228,4.228,0,0,0,1.259,1.619c.54.3,1.079.839,1.679.839H54.63c.6,0,1.2-.54,1.679-.839a3.664,3.664,0,0,0,1.259-1.439A3.547,3.547,0,0,0,57.628,51.849ZM30.409,29.427a3.3,3.3,0,1,1,6.595,0V39.5a3.3,3.3,0,1,1-6.595,0ZM34.126,51.37a3.357,3.357,0,1,1,3.357-3.357A3.352,3.352,0,0,1,34.126,51.37Z",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiversIcon2);
export default __webpack_public_path__ + "static/media/caregivers-icon2.b8dc58d65116cf2dc4619186750038a6.svg";
export { ForwardRef as ReactComponent };